import React from 'react';
import { ProgressBar } from 'shared';

function ProgramProgressBar({ progress: { daysPercentComplete, tasksPercentComplete } }) {
  return <ProgressBar primaryProgress={tasksPercentComplete * daysPercentComplete} secondaryProgress={daysPercentComplete} />;
}

export default ProgramProgressBar;
